import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider, createBrowserRouter} from 'react-router-dom'
import { CreateAnouncement, CreateStudentTestimonial, LandingPage, LandingPageLayout, RegistrationForm, LoginForm, Dashboard, StudentTable, DefaultDashboard, CreateCounsellor, Question, RegisterStudentList, AluminiSpeak, Announcments, AboutPage, AboutPageTwo, CampusLife, ProgramIntroduction, CarrerOne, PlacedStudent, PlacmentTeam, Admission, EligiblityCreteria, Scholarship, FeeStructure, Companies,  PlacmentPolicy,Approvals, AddPlacedStudents, CounsellorViewAdmin, AddFeesStructure, AddPackages, AddGalleryPhotos,TestComponent, RecognitionandApprovals, CounsellorView, TestResult, SharelinkForm, HomePageFirstComponent, Page1,Page2,Page3, EnrolledStudents, CertificateGallery, TermsAndConditions, OptimizedLandingPage} from './components';

import { AuthProvider } from './authentication/AuthContext';
import NewsScroll from './components/Website/NewsScroll';
import RoleBasedRoute from './authentication/RoleBasedRoute';
import MBABatch from './components/Dashboard/MBABatch';
import AddBlogs from './components/Dashboard/AddBlogs';
import Blogs from './components/Website/BlogsRead';
import Page4 from './components/Website/Page4';
// At the top of your index.js, after the imports
const meta = document.createElement('meta');
meta.name = "viewport";
meta.content = "width=device-width, initial-scale=1.0";
document.head.appendChild(meta);


const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPageLayout />,
    children: [
      {
        path: '',
        element: <LandingPage />
      },
      {
        path: 'register',
        element: <RegistrationForm />
      },
      {
        path: 'announcements',
        element: <Announcments />
      },
      {
        path: 'about',
        element: <AboutPage />
      },
      {
        path: '/about/mission',
        element: <AboutPageTwo />
      },
      {
        path: '/about/campus',
        element: <CampusLife />
      },
      {
        path: 'courses',
        element: <ProgramIntroduction />
      },
      {
        path: 'careers',
        element: <CarrerOne />
      },
      {
        path: 'placed-student',
        element: <PlacedStudent />
      },
      {
        path: 'placment-team',
        element: <PlacmentTeam />
      },
      {
        path: 'admission',
        element: <Admission />
      },
      {
        path: 'eligibility',
        element: <EligiblityCreteria />
      },
      {
        path: 'scholarship',
        element: <Scholarship />
      },
      {
        path: 'fees',
        element: <FeeStructure />
      },
      {
        path: 'recruiters',
        element: <Companies />
      },
      {
        path: 'contact',
        element: <HomePageFirstComponent />
      },
      {
        path: 'certifications',
        element: <CertificateGallery/>
      },
      {
        path: 'placment-policy',
        element: <PlacmentPolicy/>
      },{
        path: 'approvals',
        element: <Approvals/>
      },
      {
        path: 'news',
        element: <NewsScroll/>
      }
      ,
      {
        path: 'mba-in-hr/:city?',
        element: <Page1 />
      },
      {
        path: 'mba-in-finance/:city?',
        element: <Page2 />
      },
      {
        path: 'mba-in-sale/:city?',
        element: <Page3 />
      },
      {
        path: 'master-of-business-administration-mba/:city?',
        element: <Page4 />
      },
      {
        path: 'best-mba-college/:city?',
        element: <Page4 />
      },
      {
        path: 'mba-finance-college/:city?',
        element: <Page4 />
      } 
      ,{
        path: 'share-link',
        element: <SharelinkForm />
      },
      {
        path: 'terms',
        element: <TermsAndConditions />
      },
      {
        path: 'mbaBatch',
        element: <MBABatch />
      },      
      {
        path: 'blogs',
        element: <Blogs />
      },
      {
        path: 'finance',
        element: <OptimizedLandingPage />
      },
    ]
  }

  ,
  {
    path: '/dashboard',
    element: <RoleBasedRoute allowedRoles={[9,1]} ><Dashboard /></RoleBasedRoute>,
    children: [
      {
        path: "",
        element: <RoleBasedRoute allowedRoles={[9,1]}><DefaultDashboard /></RoleBasedRoute>
      },
      {
        path: 'enquiry',
        element: <RoleBasedRoute allowedRoles={[9,1]}><StudentTable /></RoleBasedRoute>
      },
      {
        path: 'testimonials',
        element: <RoleBasedRoute allowedRoles={[9,1]}><CreateStudentTestimonial /></RoleBasedRoute>
      },
      {
        path: 'announcements',
        element: <RoleBasedRoute allowedRoles={[9,1]}><CreateAnouncement /></RoleBasedRoute>
      },
      {
        path: 'counsellors',
        element: <RoleBasedRoute allowedRoles={[9]}><CreateCounsellor /></RoleBasedRoute>
      },
      {
        path: 'question',
        element: <RoleBasedRoute allowedRoles={[9]}><Question /></RoleBasedRoute>
      },
      {
        path: 'registerStudents',
        element: <RoleBasedRoute allowedRoles={[9,1]}><RegisterStudentList /></RoleBasedRoute>
      },
      {
        path: 'aluminis',
        element: <RoleBasedRoute allowedRoles={[9,1]}><AluminiSpeak /></RoleBasedRoute>
      },
      {
        path: 'placed-students',
        element: <RoleBasedRoute allowedRoles={[9,1]}><AddPlacedStudents/></RoleBasedRoute>
      },
      {
        path: 'assign-task/:id',
        element: <RoleBasedRoute allowedRoles={[9]}><CounsellorViewAdmin/></RoleBasedRoute>
      },
      {
        path: 'fees-structure',
        element: <RoleBasedRoute allowedRoles={[9,1]}><AddFeesStructure/></RoleBasedRoute>
      },
      {
        path: 'add-package',
        element: <RoleBasedRoute allowedRoles={[9,1]}><AddPackages/></RoleBasedRoute>
      },
      {
        path: 'gallery',
        element: <RoleBasedRoute allowedRoles={[9,1]}><AddGalleryPhotos/></RoleBasedRoute>
      },
      {
        path: 'recognitions',
        element: <RoleBasedRoute allowedRoles={[9,1]}><RecognitionandApprovals/></RoleBasedRoute>
      },
      {
        path: 'test-result',
        element: <RoleBasedRoute allowedRoles={[9,1]}><TestResult/></RoleBasedRoute>
      },
      {
        path: 'tasks',
        element: <RoleBasedRoute allowedRoles={[1]}><CounsellorView/></RoleBasedRoute>
      },
      {
        path: 'enroled',
        element: <RoleBasedRoute allowedRoles={[1,9]}><EnrolledStudents/></RoleBasedRoute>
      },
      {
        path: 'mbaBatch',
        element: <RoleBasedRoute allowedRoles={[1,9]}><MBABatch/></RoleBasedRoute>
      },
      {
        path: 'blogs',
        element: <RoleBasedRoute allowedRoles={[9,1]}><AddBlogs /></RoleBasedRoute>
      }
    ]
  },

  {
    path: "login",
    element: <LoginForm />
  },
  {
    path: 'trial',
    element: <CounsellorViewAdmin/> 
  },
  {
    path: 'test',
    element: <TestComponent/>
  },
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);


reportWebVitals();
